import jwtDecode from 'jwt-decode'
export const qualityDepartment = ['5d9b27f7d489d437f2950595']
export const retentionDepartments = [
  '5d9b2806d489d437f2950596',
  '6464bba327e0949da9056a64',
  '6400a3fd73303f9006a665cd',
  '6299cf7664de1d5aaf015ebc',
  '60746341d80dab068a744659',
  '5e843fc4a6152815d8f149dc',
  '5ddf901b245dd830d3abb463',
  '600ec8702c7fcc068372e18b',
  '643802a6597f187f3bc1f94b',
  '6287655864de1d5aafc94db7',
  '6400a3fd73303f9006a665cd',
  '5ddf902e245dd830d3abb464',
  '605061e2d80dab068a73d30d'
]
export const columnsTableStats = [
  {
    name: 'Order Type',
    label: 'Order Type',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Orders',
    label: 'Orders',
    options: {
      sortDirection: 'Orders',
      filter: false,
      sort: true
    }
  },
  {
    name: 'Orders Group',
    label: 'Orders Group',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const optionsTableStats = {
  responsive: 'scroll',
  filterType: 'multiselect',
  selectableRows: 'none',
  print: false,
  textLabels: {
    body: {
      noMatch: 'Nuk ka të dhëna'
    }
  }
}

export const columnsOrderTable = (canViewCheckbox) => [
  {
    name: 'Emri Mbiemri',
    label: 'Emri Mbiemri',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Order Type',
    label: 'Order Type',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Order Group',
    label: 'Order Group',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Order ID',
    label: 'Order ID',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'From Order Quality',
    label: 'From Order Quality',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'Activation Date',
    label: 'Activation Date',
    options: {
      filter: true,
      sort: true
    }
  },
  ...(canViewCheckbox
    ? [
        {
          name: 'Quality Check',
          label: 'Quality Check',
          options: {
            filter: false,
            sort: false,
            download: false
          }
        }
      ]
    : []),
  {
    name: 'Quality Check',
    label: 'Quality Check',
    options: {
      filter: true,
      sort: true,
      display: false,
      download: true
    }
  },
  {
    name: 'Modifiko',
    label: 'Modifiko',
    options: {
      filter: false,
      sort: false,
      download: false
    }
  }
]

export const optionsOrderTable = {
  responsive: 'scroll',
  filterType: 'dropdown',
  selectableRows: 'none',
  print: false,
  textLabels: {
    body: {
      noMatch: 'Nuk ka të dhëna'
    }
  }
}
